import { render } from "./FormCustomInput.vue?vue&type=template&id=63a79c04"
import script from "./FormCustomInput.vue?vue&type=script&lang=js"
export * from "./FormCustomInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__